<template>
  <div
    v-if="isVisibleConfirm"
    class="modal-confirm-overlay"
    @click.self="closeConfirmModal"
  >
    <div class="modal-confirm-content">
      <div class="message">{{ message }}</div>

      <div class="modal-buttons">
        <button class="btn-success" @click="closeConfirmModal">
          Confirmar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isVisibleConfirm: {
      type: Boolean,
    },
    message: {
      type: String,
      default: 'Tem certeza?',
    },
  },

  methods: {
    closeConfirmModal() {
      this.$emit('close');
    },
    confirmAction() {
      this.onConfirm();
      this.closeConfirmModal();
    },
  },
};
</script>

<style scoped>
.modal-confirm-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-confirm-content {
  background: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  text-align: center;
  display: flex;
  flex-direction: column;
}

.message {
  font-size: 18px;
  padding-bottom: 10px;
}

.modal-buttons {
  display: flex;
  justify-content: center;
  gap: 10px;
}

button {
  padding: 10px 20px;
  border: none;
  cursor: pointer;
  font-size: 16px;
  border-radius: 4px;
}

.btn-success {
  background-color: #2ed8b6;
  border-color: #2ed8b6;
  color: #fff;
  cursor: pointer;
  -webkit-transition: all ease-in 0.3s;
  transition: all ease-in 0.3s;
}

.btn-success:hover {
  background-color: #59e0c5;
  border-color: #59e0c5;
}

.btn-success:active {
  background-color: #20a98e;
  border-color: #20a98e;
  -webkit-box-shadow: none;
  box-shadow: none;
  color: #fff;
}

.btn-success:focus {
  -webkit-box-shadow: none;
  box-shadow: none;
  color: #fff;
  background-color: #59e0c5;
}

.btn-success.disabled {
  background-color: rgba(46, 216, 182, 0.5);
  border-color: rgba(46, 216, 182, 0.5);
}
</style>
